import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { BaseAnswerType } from '../../views/types';
import type { SectionsPropsType } from '../types';
import { renderSimpleButtonGroup } from '../../views/SimpleButtonGroup';
import { buildAnswers, buildUserAnswerMessage } from '../utils';
import { PREFECTURE_BY_REGION } from './consts/prefecturesByRegion';
import { renderUserMessage } from '../../views/UserMessage';

const SECTION_KEY_NAME = 'prefecture';
const PARAM_NAME = 'prefecture';
const GA_EVENT_NAME = 'prefecture';

export const prefectureSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const regionValue = userAnswers.find((answer) => answer.keyName === 'region')?.value;
  const answers: BaseAnswerType[] = PREFECTURE_BY_REGION[regionValue];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent, value } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '都道府県は',
      answer: textContent || '',
      value: value || '',
    });
  };

  // 回答ボタン表示
  const answer = await renderSimpleButtonGroup({
    ...props,
    keyName: SECTION_KEY_NAME,
    doesNotScroll: true,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
  });

  // ユーザーの吹き出し
  await renderUserMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: buildUserAnswerMessage(answer.answerText),
  });

  // 回答内容を返却する
  return answer;
};
